module.exports = __webpack_public_path__ + "img/empty-cover-photo.12c7312b.png";